import { CognitoIdentityProviderClient, InitiateAuthCommand } from '@aws-sdk/client-cognito-identity-provider';

import config from '../../config/config';
import * as tokenHelper from '../helpers/TokenHelper';

const { COGNITO_CLIENT_ID, AWS_REGION } = config;
const client = new CognitoIdentityProviderClient({ region: AWS_REGION });

export const refreshCognitoIdToken = () => {
  const refreshToken = tokenHelper.getRefreshToken();
  if (!refreshToken) return false;

  const command = new InitiateAuthCommand({
    AuthFlow: 'REFRESH_TOKEN',
    AuthParameters: {
      REFRESH_TOKEN: refreshToken
    },
    ClientId: COGNITO_CLIENT_ID
  });
  return client.send(command);
};
